import { render, staticRenderFns } from "./CreateEditTemplate.vue?vue&type=template&id=02c4fc80&scoped=true&"
import script from "./CreateEditTemplate.vue?vue&type=script&lang=js&"
export * from "./CreateEditTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c4fc80",
  null
  
)

export default component.exports